import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  onClick() {
    window.document.body.setAttribute('data-should-show-site-search-bar', true);
  }
}
